import Box from "@mui/material/Box";
import * as theme from '../../../theme';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import TextField from "@mui/material/TextField";
import PractitionerConsentForm from '../../../components/PractitionerConsentForm';

export default function ConsentTerms({ consentData, handleConsentChange, practitionerName, formData }) {
  return (
    <Box sx={{ ...theme.FullForm.form, gap: 4, marginBottom: 6 }}>
      <Box sx={{ p: 2, border: 1, borderColor: theme.Colors.GrayLight, borderRadius: 1 }}>
        <div style={theme.SubHeadingText}>
          <PractitionerConsentForm practitionerName={practitionerName} />
        </div>
      </Box>
      <FormControlLabel
        control={<Checkbox name="agreed" checked={consentData.agreed} onChange={handleConsentChange} required />}
        label="Yes, I agree to the terms of the TruBalance Practitioner Agreement."
      />
      <Box>
        <div style={{ ...theme.SubHeadingText, margin: 0 }}>
          {`${formData.firstName} ${formData.lastName}`}
          {formData.businessName && <><br /><strong>{formData.businessName}</strong></>}
        </div>
      </Box>
      <TextField
        label="Signature (Type Your Full Name)"
        name="signature"
        value={consentData.signature}
        onChange={handleConsentChange}
        variant="filled"
        required
        fullWidth
      />
    </Box>
  );
}